import { Box, SxProps, Theme } from "@mui/material";
import { ConvertMprcColorsToString } from "components";
import * as React from "react";

interface IProps {
    component?: React.ElementType;
    children?: React.ReactNode;
    color?: MprcColorsExtended | [MprcColors, MprcColorVariant] | "inherit";
    bold?: boolean;
    uppercase?: boolean;
    reverse?: boolean;
    title?: string;
}

type Props = IProps;

export const MprcText: React.FC<Props> = (props) => {
    const {
        children,
        color = ["primary", "main"],
        uppercase = false,
        bold = false,
        reverse = false,
        component = "span",
        ...rest
    } = props;

    const sxProps: SxProps<Theme> = (theme) => {
        var fgc = reverse
            ? theme.palette.common.white
            : (color == "inherit" ? "inherit" : ConvertMprcColorsToString(theme, color));

        var bgc = reverse
            ? (color == "inherit" ? "inherit" : ConvertMprcColorsToString(theme, color))
            : undefined;

        return ({
            fontWeight: bold ? "bold" : undefined,
            textTransform: uppercase ? "uppercase" : undefined,
            color: fgc,
            backgroundColor: bgc,
            paddingLeft: reverse ? "2px" : undefined,
            paddingRight: reverse ? "2px" : undefined
        });
    };

    return (
        <Box
            {...rest}
            sx={sxProps}
            component={component}
        >
            {children}
        </Box>
    );
};
